import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const Hero = () => {
    const [currentTextIndex, setCurrentTextIndex] = useState(0);
    const [isMobile, setIsMobile] = useState(false);

    const animatedTexts = [
        "Building Your Dream Home",
        "Quality Construction Since 2007",
        "Creating Spaces That Inspire",
        "Excellence in Every Detail"
    ];

    useEffect(() => {
        // Check if mobile on mount and window resize
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        // Rotate animated text every 4 seconds
        const interval = setInterval(() => {
            setCurrentTextIndex((prev) => (prev + 1) % animatedTexts.length);
        }, 4000);

        return () => {
            window.removeEventListener('resize', handleResize);
            clearInterval(interval);
        };
    }, [animatedTexts.length]);

    return (
        <section className="relative h-screen w-full overflow-hidden">
            {/* Video Background */}
            <div className="absolute inset-0 z-0">
                {isMobile ? (
                    <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="object-cover h-full w-full"
                    >
                        <source src="https://arcdom.b-cdn.net/hero/mobile-hero.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                ) : (
                    <video
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="object-cover h-full w-full"
                    >
                        <source src="https://arcdom.b-cdn.net/hero/hero.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                )}
                {/* Dark overlay */}
                <div className="absolute inset-0 bg-black opacity-30"></div>
            </div>

            {/* Hero Content */}
            <div className="relative z-10 h-full flex flex-col justify-center items-center text-white px-4">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="text-center"
                >
                    <h1 className="text-5xl md:text-7xl font-bold font-fira mb-6 text-arcdom-gold">ARCDOM</h1>
                    <motion.div
                        key={currentTextIndex}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -20 }}
                        transition={{ duration: 0.5 }}
                        className="h-16"
                    >
                        <p className="text-2xl md:text-4xl font-montserrat text-[#eceeF1]">
                            {animatedTexts[currentTextIndex]}
                        </p>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: 0.5 }}
                        className="mt-12"
                    >
                        <a
                            href="#contact"
                            className="bg-arcdom-gold text-arcdom-navy py-3 px-8 rounded-md font-medium hover:bg-opacity-90 transition-all duration-300 inline-block"
                        >
                            Contact Us
                        </a>
                    </motion.div>
                </motion.div>

                {/* Scroll down indicator */}
                <motion.div
                    className="absolute bottom-10 transform -translate-x-1/2"
                    animate={{ y: [0, 10, 0] }}
                    transition={{ duration: 2, repeat: Infinity }}
                >
                    <div className="flex flex-col items-center">
                        <p className="text-sm mb-2">Scroll Down</p>
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M12 5V19M12 19L5 12M12 19L19 12"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                </motion.div>
            </div>
        </section>
    );
};

export default Hero;
